import type { QuoteBudgetLine } from "../types";

/** 与服务端 legacy_bus_groups 保持一致，仅按来源引用及唯一的推荐价天次归属补全旧组。 */
export function completeLegacyBusSources(replaced: QuoteBudgetLine[], baseline: QuoteBudgetLine[]): string[] {
  const rows = baseline.filter(line => line.resourceType === "包车" && !line.entrySnapshot);
  const groups = new Map<string, string[]>();
  for (const row of rows) {
    let ref = row.priceSourceRef || row.budgetLineId;
    if (ref.startsWith("resource_sku_price:") && row.resourceEntryType === "包车固定费") {
      const match = /^D(\d+)(?:-D?(\d+))? 用车固定费$/u.exec(row.itemNameSnapshot ?? "");
      const start = Number(match?.[1]), end = Number(match?.[2] ?? match?.[1]);
      const candidates = new Set(rows.filter(other => {
        if (!match || start > end || other.resourceEntryType !== "包车燃油费") return false;
        const scope = /^(manual_bus|bus_section):(local_charter|pickup|dropoff|stay_interval|day):D?(\d+)(?:-D?(\d+))?$/u.exec(other.priceSourceRef ?? "");
        if (!scope) return false;
        const first = Number(scope[3]), last = Number(scope[4] ?? scope[3]);
        const local = scope[2] === "local_charter" || (scope[1] === "bus_section" && ["stay_interval", "day"].includes(scope[2]));
        return first >= 1 && last >= first && last - first <= 365 && (local || first === last) && start >= first && end <= last;
      }).map(other => other.priceSourceRef!));
      if (candidates.size === 1) ref = [...candidates][0];
    }
    groups.set(ref, [...groups.get(ref) ?? [], row.budgetLineId]);
  }
  const selected = new Set(replaced.flatMap(line => line.replacesLineIds?.length ? line.replacesLineIds
    : line.resourceType === "包车" && !line.entrySnapshot ? [line.budgetLineId] : []));
  for (const ids of groups.values()) if (ids.some(id => selected.has(id))) ids.forEach(id => selected.add(id));
  return [...selected];
}
